<template>
  <div>
    <loadArea v-if="model == null || currencies == null"></loadArea>
    <Form
      method="dialog"
      v-slot="{ errors }"
      v-if="model != null && currencies != null"
      class="floating-labels p-1rem row"
      ref="form"
    >
      <div class="col-md-4">
        <formGroup
          :title="'Name'"
          v-model="model.Name"
          :errors="errors"
          :rules="{ required: true }"
          @keydown.enter="save"
        ></formGroup>
      </div>
      <div class="col-md-4">
        <formGroup
          :title="'ShortName'"
          v-model="model.ShortName"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </div>
      <div class="col-md-4">
        <formGroup
          :title="'MainOperatorId'"
          :as="'select'"
          :disabled="operators.length == 0"
          v-model="model.MainOperatorId"
          :errors="errors"
          @keydown.enter="save"
        >
          <template #input>
            <option :value="null"></option>
            <option
              v-for="item in operators"
              :value="item.Id"
              :key="item.Code"
              >{{ item.Name }}</option
            >
          </template>
        </formGroup>
      </div>
      <div class="col-md-4">
        <formGroup
          :title="'CurrencyCode'"
          :as="'select'"
          :disabled="currencies.length == 0"
          :buttons="true"
          v-model="model.CurrencyCode"
          :errors="errors"
          @keydown.enter="save"
        >
          <template #input>
            <option :value="null"></option>
            <option
              v-for="item in currencies"
              :value="item.Code"
              :key="item.Code"
              >{{ item.Name }}</option
            >
          </template>
          <template #buttons>
            <button
              type="button"
              @click="addCurrenciesOpen = true"
              class="btn waves-effect waves-light btn-success"
            >
              <i class="fas fa-plus"></i>
            </button>
          </template>
        </formGroup>
      </div>
      <div class="col-md-4">
        <formGroup
          :title="'USD'"
          type="number"
          v-model="model.USD"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </div>
      <div class="col-md-4">
        <formGroup
          :title="'EUR'"
          type="number"
          v-model="model.EUR"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </div>
      <div class="col-md-3">
        <formGroup
          :title="'MaxHotelCount'"
          type="number"
          v-model="model.MaxHotelCount"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </div>
      <div class="col-md-3">
        <formGroup
          :title="'MaxDayCount'"
          type="number"
          v-model="model.MaxDayCount"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </div>
      <div class="col-md-3">
        <formGroup
          :title="'OutputCount'"
          type="number"
          v-model="model.OutputCount"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </div>
      <div class="col-md-3">
        <formGroup
          :title="'RetryCount'"
          type="number"
          v-model="model.RetryCount"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </div>
      <div class="col-md-3">
        <formGroup
          :title="'ScanModel'"
          type="number"
          v-model="model.ScanModel"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </div>
      <div class="col-md-3">
        <formGroup
          :title="'WorkBy'"
          type="number"
          v-model="model.WorkBy"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </div>
      <div class="col-md-3">
        <formGroup
          :title="'OutputPort'"
          type="number"
          v-model="model.OutputPort"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </div>
      <div class="col-md-3">
        <formGroup
          :title="'OutputExpireMinute'"
          type="number"
          v-model="model.OutputExpireMinute"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </div>
      <div class="col-md-4">
        <formGroup
          :title="'TourvisorId'"
          type="number"
          v-model="model.TourvisorId"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </div>
      <div class="col-md-4">
        <formGroup
          :title="'AviantaId'"
          type="number"
          v-model="model.AviantaId"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </div>
      <div class="col-md-4">
        <formGroup
          :title="'LocalCountryId'"
          type="number"
          v-model="model.LocalCountryId"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </div>
      <div class="col-md-4">
        <formGroup
          :title="'P1'"
          v-model="model.P1"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </div>
      <div class="col-md-4">
        <formGroup
          :title="'P2'"
          v-model="model.P2"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </div>
      <div class="col-md-4">
        <formGroup
          :title="'P3'"
          v-model="model.P3"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </div>
      <div class="col-auto">
        <formGroup
          :title="'UsingSameHotelsWithMainOperator'"
          as="checkbox"
          v-model="model.UsingSameHotelsWithMainOperator"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </div>
      <div class="col-auto">
        <formGroup
          :title="'IsPortal'"
          as="checkbox"
          v-model="model.IsPortal"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </div>
      <div class="col-auto">
        <formGroup
          :title="'IsLocalOperator'"
          as="checkbox"
          v-model="model.IsLocalOperator"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </div>
      <div class="col-auto">
        <formGroup
          :title="'ListScan'"
          as="checkbox"
          v-model="model.ListScan"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </div>
      <div class="col-auto">
        <formGroup
          :title="'Active'"
          as="checkbox"
          v-model="model.Active"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </div>
    </Form>
    <div class="modal-footer" v-if="model != null && currencies != null">
      <Btn class="btn-success btn-md" @click="save" :process="process"
        >Update Operator</Btn
      >
    </div>
  </div>
  <addCountries
    v-if="addCountriesOpen"
    @close="addCountriesOpen = false"
    @add="countries.push({ Id: $event.Id, Name: $event.Name })"
  ></addCountries>
</template>

<script>
import addCountries from "@/views/countries/upsert";
export default {
  props: {
    id: Number,
    operators: Array,
  },
  components: { addCountries },
  data() {
    return {
      model: null,
      process: false,
      currencies: null,
      addCurrenciesOpen: false,
    };
  },
  created() {
    this.$appAxiosAdmin.get(`Currencies`).then((response) => {
      this.currencies = response.data;
    });
    this.$appAxiosAdmin.get(`Operators/` + this.id).then((response) => {
      this.model = response.data;
    });
  },
  methods: {
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          this.$appAxiosAdmin
            .put(`Operators`, this.model)
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The operator has been successfully updated.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              this.$emit("update", response.data);
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style></style>
